export default __webpack_public_path__ + "static/media/delivery.52486b7d.png";